import { useState } from 'react'
import { Table } from 'react-bootstrap'
import { useGroupsQuery } from '@data/rbac/rbac'
import { Group, Role } from '@data/users/model/user'
import DeleteModal from '../../../general/Modals/DeleteModal'

import './GroupsComponent.scss'

const GroupsComponent = () => {
  const { data: groups = [], isLoading: loading } = useGroupsQuery()
  const [deleteRole, setDeleteRole] = useState<{ group: Group; role: Role }>()

  return (
    <>
      {loading ? (
        'Loading...'
      ) : (
        <>
          <DeleteModal
            show={!!deleteRole}
            data={deleteRole}
            onHide={() => setDeleteRole(undefined)}
            toString={(data: any) => `${data.role.description} from ${data.group.description}`}
            onDelete={(data: any) => console.log(data)}
          />
          <Table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Description</th>
                <th>Roles</th>
                <th>&nbsp;</th>
              </tr>
            </thead>
            <tbody>
              {groups.map((group) => (
                <tr key={group.id}>
                  <td>{group.name}</td>
                  <td>{group.description}</td>
                  <td>
                    <ul>
                      {group.roles.map((r) => (
                        <li key={r.name}>
                          {r.description}
                          <i
                            className="fas fa-times"
                            style={{ color: 'red', cursor: 'pointer' }}
                            onClick={() => setDeleteRole({ group, role: r })}
                          ></i>
                        </li>
                      ))}
                    </ul>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </>
      )}
    </>
  )
}

export default GroupsComponent
